import styled from "styled-components";

import { AuthModalButtonContainer } from "../../atoms/AuthModalButton/styles";
import { AuthModalHeaderTitleContainer } from "../../atoms/AuthModalHeaderTitle/styles";

export const InitialAuthModalContainer = styled.div`
  width: 100%;
  height: 100%;

  max-width: 360px;
  margin: 0 auto;

  padding-bottom: 2.375rem;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;

  gap: 4.5rem;

  .auth-modal-header-title {
    all: unset;
    color: ${({ theme }) => theme.authModal.primaryText};
    font: 600 1.375rem/1.719rem "Inter";
    text-align: center;
    max-width: 223px;
  }

  .loader {
    width: 1rem;
    height: 1rem;
  }

  ${AuthModalHeaderTitleContainer} {
    margin: 0;
  }

  animation: appearFromLeft 0.4s;

  @keyframes appearFromLeft {
    from {
      opacity: 0;
      transform: translateX(-5px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

export const InitialAuthModalButtons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  gap: 0.75rem;

  width: 100%;

  ${AuthModalButtonContainer} {
    width: 100%;
  }
`;
